module.exports = __webpack_public_path__ + "img/feature-8.1d0a8621.jpg";